// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1oWyS","disabled":"FileBtn_disabled__2MFU1","warn":"FileBtn_warn__1TaHo","fade":"FileBtn_fade__1P_lO"};